var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['pre-loader', { show: _vm.isVisible }]},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-loader__block"},[_c('div',{staticClass:"spinner spinner-1"})])}]

export { render, staticRenderFns }